export default function initReadMore() {
    let readMore = document.querySelectorAll('.read-more');

    readMore.forEach((readMore) => {
        let active = false;
        let readMoreButton = readMore.querySelector('.read-more-button');

        readMoreButton.addEventListener("click", toggle);

        function toggle() {
            if(!active) {
                open();
            } else {
                close();
            }
        }

        function open() {
            active = true;
            readMore.classList.add("active");
        }

        function close() {
            readMore.classList.remove("active");
            active = false;
        }
    });
}